import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pen",
  "use": "icon-pen-usage",
  "viewBox": "0 0 11 11",
  "content": "<symbol viewBox=\"0 0 11 11\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-pen\">\n<path d=\"M10.8167 2.44445C11.0611 2.2 11.0611 1.83334 10.8167 1.58889L9.41111 0.183336C9.16666 -0.0611121 8.8 -0.0611121 8.55555 0.183336L7.45555 1.28334L9.77778 3.60557L10.8167 2.44445ZM0 8.67777V11H2.32223L9.04444 4.21667L6.72222 1.89444L0 8.67777Z\" fill=\"#1890FF\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol